export default __webpack_public_path__ + "static/media/1518.52ccdfa1.png";